import { Button } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import { IconLock } from "@tabler/icons-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React from "react";
import { TaskCompletedCount } from "../../../components";
import { ActionIcon, IssueIcon } from "../../../components/CustomIcons/CustomIcons";
import { getTaskCompleteCount } from "./issueUtils";

export const IssueIdWithAksjonCompletedCount: React.FC<{
  issue: IIssueApi;
  setSelectedIssue: (issue: IIssueApi) => void;
  id: string;
  showClientLock?: boolean;
}> = ({ issue, setSelectedIssue, id, showClientLock = false }) => {
  return (
    <div className="d-flex align-items-center">
      {issue._id != null && <IssueIdButton issue={issue} setSelectedIssue={setSelectedIssue} id={id} />}
      {showClientLock === true && (
        <IconLock color="var(--mantine-color-red-6)" size={16} style={{ flexShrink: 0, marginLeft: 4 }} />
      )}
      <div className="flex-fill" />
      <TaskCompletedCount taskCompleteCount={getTaskCompleteCount(issue, true)} />
    </div>
  );
};

export const IssueIdButton: React.FC<{ issue: IIssueApi; setSelectedIssue: (issue: IIssueApi) => void; id: any }> = ({
  issue,
  setSelectedIssue,
  id,
}) => {
  return (
    <Button color="mc-primary" variant="subtle" px="xs" size="sm" onClick={() => setSelectedIssue(issue)}>
      {issue.taskOrIssue === "ISSUE" && (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          <IssueIcon style={{ fontSize: ".9em", display: "block" }} />
          <b>
            <u>{id}</u>
          </b>
        </span>
      )}
      {issue.taskOrIssue === "TASK" && (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          <ActionIcon style={{ fontSize: "1.1em", color: "var(--mantine-color-gray-6)", display: "block" }} />
          <span>{id}</span>
        </span>
      )}
    </Button>
  );
};
